import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 0 40px;
    max-width: 1800px;
    margin: 0 auto;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0;
    }
  `}
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Row = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 13px 0px;

    @media (max-width: ${theme.v2.breakpoints.md}){
      background-color: ${theme.v2.colors.neutral.highPure};
      color: ${theme.v2.colors.neutral.lowMedium};
      padding: 20px 16px;
    }

    @media (min-width: ${theme.v2.breakpoints.md}) {
      height: 78px;
    }
  `}
`;

export const IconWrapper = styled.div`
  ${({ theme, handleFill }) => css`
    display: flex;

    > div {
      display: flex;
    }

    svg {
      fill: ${!handleFill && theme.v2.colors.neutral.lowMedium};

      @media (max-width: ${theme.v2.breakpoints.md}){
        fill: ${!handleFill && theme.v2.colors.neutral.lowMedium};
      }
    }
  `}
`;

export const IconButton = styled.button`
  background-color: transparent;
  border: 0px;
  cursor: pointer;
  display: flex;
`;

export const PageName = styled.h1`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowMedium};
    display: flex;
    flex-direction: row;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 16px;
    line-height:${theme.v2.font.lineHeight.text};
    margin: 0px 0px 0px 8px;
    max-width: 600px;

    @media (max-width: ${theme.v2.breakpoints.md}){
      color: ${theme.v2.colors.neutral.lowMedium};
      font-size: ${theme.v2.font.sizes.xs};
    }

    @media (max-width: ${theme.v2.breakpoints.sm}){
      max-width: 130px;
      gap: 4px;
    }

    @media (max-width: ${theme.v2.breakpoints.xs}){
      color: ${theme.v2.colors.neutral.lowMedium};
      font-size: ${theme.v2.font.sizes.xs};
      max-width: 100px;
    }
  `}
`;

export const ActionsWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 32px;

    div {
      right: 0px;
    }

    button {
      white-space: nowrap;

      svg {
        flex: 0 0 24px;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.md}){
      display: none;
    }
  `}
`;

export const FirstFloatingWrapper = styled.div`
  align-items: center;
  display: flex;

  > div > div > div:first-child {
    button{
      padding: 6px 16px;
    }
  }
`;

export const LastFloatingWrapper = styled.div`
  align-items: center;
  display: flex;

  > div > div > div:first-child {
    button{
      padding: 6px 0px 6px 8px;
    }
  }
`;

export const MerlinWrapper = styled.div`
   ${({ theme }) => css`
     z-index: 1000;
     position: fixed;
     right: 0;
     bottom: 0;
     height: 100vh;
     width: 480px;
     display: flex;
     align-items: flex-end;
     justify-content: center;
     @media (max-width: ${theme.v2.breakpoints.md}) {
       height: 100vh;
       width: 100%;
     }
   `}
`;

export const Merlin = styled.iframe`
  z-index: 1000;
  height: 100%;
  width: 100%;
  border: 0;
  border-left: 1px solid #CDD8DF;
`;

export const ReferrerWrapper = styled.a`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-left: 16px;
  width: 100%;
  height: 100%;
`;

export const ReferrerText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[50]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
  `}
`;
